module.exports = __webpack_public_path__ + "show_balance_icon.png?ee682167ac83460b957a4ea4f4de8491";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/show_balance_icon.png
// module id = 1031
// module chunks = 2